// project-import
import { ThemeMode } from 'config';

// ==============================|| PRESET THEME - JARAMILLO MORA NEGRO/GRIS + ROJO (THEME10) ||============================== //

export default function Theme10(colors, mode) {
  const { grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  // Primary: negro corporativo #231F20 (light) → gris #58595B (mid) → black
  // Secondary: rojo corporativo #ED1C24 as brand accent (distinct from error)
  // Error: orange-red to visually separate from brand red

  let primaryColors = ['#f0eef0', '#c8c5c6', '#a09c9d', '#787374', '#504c4d', '#231F20', '#1c191a', '#141213', '#0d0b0c', '#060506'];
  let secondaryColors = ['#fde8e9', '#f8a4a7', '#f47378', '#f04650', '#ed2a32', '#ED1C24', '#c4161e', '#9b1018', '#720b11', '#48050a'];
  // Error uses orange-red (Deep Orange) — visually distinct from the pure brand red
  let errorColors = ['#FFF2ED', '#FFAB91', '#FF7043', '#F4511E', '#BF360C'];
  let warningColors = ['#FFF7E0', '#FFC926', '#FFBF00', '#FFB900', '#FFA900'];
  let infoColors = ['#E6F0FA', '#4D9FE0', '#1677C7', '#1168B8', '#0A52A0'];
  let successColors = ['#E0F5EA', '#26B56E', '#00A854', '#00A04D', '#008D3A'];

  if (mode === ThemeMode.DARK) {
    // Primary lightens so it is visible on dark backgrounds
    primaryColors = ['#1c1a1b', '#302d2e', '#454243', '#595657', '#6e6b6c', '#8b8788', '#a09c9d', '#b8b5b6', '#d0cdce', '#e8e6e7'];
    secondaryColors = ['#2d1a1b', '#5a1a1e', '#8c1c22', '#b81e27', '#d42030', '#c41820', '#a81420', '#8c101a', '#700c14', '#54080e'];
    errorColors = ['#2d1e17', '#6b3520', '#b5531a', '#d4722a', '#f0a070'];
    warningColors = ['#342c1a', '#836611', '#dda705', '#e9bf28', '#f8e577'];
    infoColors = ['#1a2030', '#113366', '#1553b0', '#2d6cc7', '#6d9fe0'];
    successColors = ['#1a2721', '#115c36', '#05934c', '#1da65d', '#61ca8b'];
  }

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    },
    secondary: {
      lighter: secondaryColors[0],
      100: secondaryColors[1],
      200: secondaryColors[2],
      light: secondaryColors[3],
      400: secondaryColors[4],
      main: secondaryColors[5],
      dark: secondaryColors[6],
      700: secondaryColors[7],
      darker: secondaryColors[8],
      900: secondaryColors[9],
      // Keep A-variants neutral so text/icon overrides still work
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText
    },
    error: {
      lighter: errorColors[0],
      light: errorColors[1],
      main: errorColors[2],
      dark: errorColors[3],
      darker: errorColors[4],
      contrastText
    },
    warning: {
      lighter: warningColors[0],
      light: warningColors[1],
      main: warningColors[2],
      dark: warningColors[3],
      darker: warningColors[4],
      contrastText: greyColors[100]
    },
    info: {
      lighter: infoColors[0],
      light: infoColors[1],
      main: infoColors[2],
      dark: infoColors[3],
      darker: infoColors[4],
      contrastText
    },
    success: {
      lighter: successColors[0],
      light: successColors[1],
      main: successColors[2],
      dark: successColors[3],
      darker: successColors[4],
      contrastText
    },
    grey: greyColors
  };
}
